/* js/responsive-table.js */

;(function ($, window, document) {

    if (typeof $.fn.dataTable === 'undefined') {
        return false;
    }

    $.extend($.fn.dataTable.defaults, {
        responsive: true
    });

    $(document).ready(function () {

        $('table.dataTable').DataTable({
            "searching": false,
            "paging": false,
            "lengthChange": false,
            "info": false,
            "columnDefs": [
                {'width': '60%', 'targets': 0},
                {'width': '10%', 'targets': 1, 'orderable': false},
                {'width': '5%', 'targets': 2, 'orderable': false},
                {'width': '20%', 'targets': 3},
                {'width': '5%', 'targets': 4, 'orderable': false}
            ],
        });

    });

})(jQuery, window, document);